import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'

import SearchBox from 'billing/common/SearchBox'
import CircularProgress from 'material-ui/CircularProgress'

const EventItem = ({ referencedEvent, onEventSelected }) => {
  return (
    <div style={styles.eventInfo} onClick={onEventSelected}>
      <div style={styles.eventName}>{ referencedEvent.name }</div>
      <div style={styles.eventDate}>
        {
          referencedEvent.startDate
            ? `${referencedEvent.startDate} - ${referencedEvent.endDate}`
            : `${referencedEvent.endDate}`
        }
      </div>
    </div>
  )
}

EventItem.propTypes = {
  referencedEvent: PropTypes.object.isRequired,
  onEventSelected: PropTypes.func.isRequired
}

export default class AddCustomerEventDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    anchorElement: PropTypes.object,
    events: PropTypes.array,
    onEventSelected: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      searchTerm: ''
    }
  }

  handleSearchBoxValueChanged = searchTerm => {
    this.setState({ searchTerm })
  }

  render() {
    if (!this.props.open) {
      return null
    }
    let content
    if (!this.props.events) {
      content = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (!this.props.events.length) {
      content = <div style={styles.zeroItems}>No events found for the selected customer/contact</div>
    }
    else {
      content = this.props.events
        .filter(material => material.name.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) >= 0)
        .map((referencedEvent, index) =>
          <EventItem
            key={index}
            referencedEvent={referencedEvent}
            onEventSelected={() => this.props.onEventSelected(referencedEvent)} />)
    }
    return (
      <Popover
        open={this.props.open}
        anchorEl={this.props.anchorElement}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        style={{ borderRadius: 4 }}
        useLayerForClickAway={false} // Avoid flashy effect when rendering the popover.
        onRequestClose={this.props.onCloseRequested}>
        <SearchBox
          onValueChanged={this.handleSearchBoxValueChanged} />
        <div style={styles.container}>
          <div style={styles.scroll}>
            <div style={styles.eventsContainer}>
              { content }
            </div>
          </div>
        </div>
      </Popover>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    border: '1px solid #e2e2e2',
    maxHeight: 250
  },
  scroll: {
    overflow: 'auto',
    width: 300
  },
  eventsContainer: {
    marginTop: 7,
    marginBottom: 7
  },
  eventInfo: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 12,
    cursor: 'pointer'
  },
  eventName: {
    color: '#4a4a4a',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  eventDate: {
    color: '#9b9b9b',
    fontSize: 12
  },
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  zeroItems: {
    textAlign: 'center',
    color: '#9b9b9b',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/AddCustomerEventDialog.js